import React from 'react';
import GxList from '../../gx/GxList';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import * as FxDat from '../../fx/FxDat';
import { useNav } from '../../hx/useNav';

import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreEmployee } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxEmployeeList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const size = useWindowSize();
  const [storeEmployee, setStoreEmployee] = useSessionStorage('StoreEmployee', StoreEmployee);

  const r_list = React.useRef(null);

  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxEmployeeList.addcol_txBranchId') === '1') };

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  React.useEffect(() => {
    clearStore('StoreEmployee', storeEmployee);
    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {

    if (row === null) {
      storeEmployee.inEmployee = null;
    } else {
      storeEmployee.inEmployee = row.original.inEmployee;
    }
    setStoreEmployee(storeEmployee);

    navTo("employee-form");
  }

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inEmployee", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: "xx1", Header: trans('field.branch_id'), accessor: "txBranchId", highlight: true, width: '5%', show: hasColumnBranchId() });
        cols.push({ id: id++, Header: trans('field.employee'), accessor: "txEmployee", highlight: true, width: '40%' });
        cols.push({ id: id++, Header: trans('field.type'), accessor: "txTypeEmployee", width: '20%' });
        cols.push({ id: id++, Header: trans('field.email'), accessor: "txEmail", width: '20%' });
        cols.push({ id: id++, Header: trans('field.mobile'), accessor: "txMobile", width: '10%' });
        cols.push({ id: id++, Header: trans('field.from'), accessor: row => ( FxTable.cellToLocalDate(row["dtFrom"]) ), width: '10%' });
      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: trans('field.employee'), accessor: "txEmployee", highlight: true, width: '70%' });
        cols.push({ id: id++, Header: trans('field.mobile'), accessor: "txMobile", width: '30%' });
      }
      cols.push({ id: "B", Header: "linked_to_user", accessor: row => Boolean(row["inUser"]), show: false });
      cols.push({ id: "A", Header: "inactive", accessor: row => FxDat.isExpired(row["dtTo"]), show: false });

    } catch(error) {
      FxLog.errorx('MxEmployeeList.getTableColumns', error)
    }
    return cols;
  }

  const getTooltip = () => {
    let tip = `${trans('field.employee')}`;
    if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
    return tip;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxEmployeeList.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.employees')}`}
        xref={r_list}
        tooltip={getTooltip()}
        fullscreen
        url="employees"
        onOpenForm={openForm}
        refColors={ [ 
          'table_cell_color_blue|' + trans('field.linked_to_x','field.user'),
          'table_cell_color_gray|' + trans('field.inactive'), 
        ] }
        columns={getTableColumns()}
        optionalColumns={getTableOptionalCols()}
        onOptions={optionsSelected}
      />

    </div>
  );

}

export default MxEmployeeList;